// The reason a request was refused, in the operator's words, or null when the response carries
// none. The BackOffice API answers a refused trip with the ModelState dictionary
// ({ Schedules: ["..."] }), a failed create with a plain string, and some endpoints with a
// { message } or { errors: {...} } envelope. The server phrases its reasons in English; the ones
// an operator can run into on the trip form are translated here.
const TRANSLATED: Record<string, string> = {
  "A stop lies at or after the trip's arrival!":
    "Një ndalesë është në ose pas arritjes së udhëtimit.",
  "Two stops share the same time after the departure!":
    "Dy ndalesa kanë të njëjtën kohë pas nisjes.",
  "The stops are out of order!": "Ndalesat nuk janë sipas radhës së udhëtimit.",
  "A stop is reached before the previous stop leaves!":
    "Një ndalesë arrihet para se ndalesa e mëparshme të niset.",
  "Invalid schedule times !": "Oraret e ndalesave nuk janë të vlefshme.",
  "Invalid time duration !": "Qëndrimet në ndalesa e kalojnë kohëzgjatjen e udhëtimit.",
  "Invalid schedule stations!": "Një stacion përsëritet te ndalesat.",
  "Schedule station can't be same as line station!":
    "Një ndalesë nuk mund të jetë stacioni i nisjes ose i arritjes së linjës."
};

const firstText = (value: unknown): string | null => {
  if (typeof value === "string") return value.trim() || null;
  if (Array.isArray(value)) {
    for (const item of value) {
      const text = firstText(item);
      if (text) return text;
    }
  }
  return null;
};

export const serverReason = (error: unknown): string | null => {
  const data = (error as { response?: { data?: unknown } } | undefined)?.response?.data;
  if (data === undefined || data === null) return null;
  let raw: string | null = null;
  if (typeof data === "string") raw = data.trim() || null;
  else if (typeof data === "object") {
    const record = data as Record<string, unknown>;
    const errors =
      record.errors && typeof record.errors === "object"
        ? (record.errors as Record<string, unknown>)
        : record;
    for (const value of Object.values(errors)) {
      raw = firstText(value);
      if (raw) break;
    }
    if (!raw && typeof record.message === "string") raw = record.message.trim() || null;
  }
  if (!raw) return null;
  return translateServerMessage(raw);
};

// A server message in the operator's words when one is known, otherwise as sent.
export const translateServerMessage = (text: string): string => TRANSLATED[text.trim()] ?? text;

// A toast line: the generic message, followed by the server's reason when it gave one.
export const withServerReason = (message: string, error: unknown): string => {
  const reason = serverReason(error);
  return reason ? `${message} ${reason}` : message;
};

// The sentence the admin can act on: a bare-string body, else the envelope's message, else the
// fallback. Unlike serverReason it never reads `errors`, where a refusal (409) carries its code.
export const resolveError = (err: unknown, fallback: string): string => {
  const data = (err as { response?: { data?: unknown } } | undefined)?.response?.data;
  if (typeof data === "string" && data) return data;
  const message = (data as { message?: unknown } | undefined)?.message;
  if (typeof message === "string" && message) return message;
  return fallback;
};
